<template>
  <div style="height:100%">
    <el-card class="box-card" :body-style="{padding:'4px'}" style="display: flex;flex-direction: column;height: 100%;">
      <div slot="header">
        <b-row style="padding: 4px; ">
        <b-col sm="auto" style="padding-top: 6px; padding-right: 2px">
          <i class="iconfont icon-search"></i>
        </b-col>
        <b-col sm="auto" class="pl-1">
          BOM版本1：
          <el-input placeholder="请输入BOM编号" v-model="BOMVersion1" style="width:200px" class="mr-1" clearable></el-input>
          BOM版本2：
          <el-input placeholder="请输入BOM编号" v-model="BOMVersion2" style="width:200px" clearable></el-input>
        </b-col>
        <b-col class="pl-1">
          <QueryButton @on_query="getDiff" :label="$t('common.query')"></QueryButton>
          <el-checkbox class="ml-2" v-model="folding" @change="foldingChanged">仅差异</el-checkbox>
        </b-col>
      </b-row>
      </div>
      <div name="code_diff_div" style="height:100%;border:1px solid grey; overflow-y: auto;">
        <code-diff v-show="isShow" :highlight="false" fileName="BomVersion" :context="100000" :old-string="prev" :new-string="current"
          output-format="side-by-side" :renderNothingWhenEmpty="false" :isShowNoChange="true" :trim="true" :drawFileList="false"
          :noDiffLineFeed="false" />
        <el-empty v-show="!isShow" :image-size="200"></el-empty>
      </div>
    </el-card>

  </div>
</template>
<script>
import QueryButton from "../components/base/QueryButton.vue";
import * as InventBomController from "../../controllers/sd/InventBomController";
import { CodeDiff } from 'v-code-diff'

export default {
  components: {
    CodeDiff,
    QueryButton
  },
  data() {
    return {
      bomDetailFields: InventBomController.fields.bom_detail,
      showContext: false,
      BOMVersion1: "",
      BOMVersion2: "",
      prev: "",
      current: "",
      isShow: false,
      folding: false,
    }
  },
  mounted() {
    // this.getDiff();
  },
  methods: {
    async getDiff(cb) {
      cb(null);
      if (this.BOMVersion1 == "") {
        this.msgToasts("请输入BOM版本1！", "info");
        return;
      }
      if (this.BOMVersion2 == "") {
        this.msgToasts("请输入BOM版本2！", "info");
        return;
      }
      let orig1 = null, orig2 = null;
      this.BOMVersion1 = _.trim(this.BOMVersion1);
      this.BOMVersion2 = _.trim(this.BOMVersion2);
      this.showContext = true;
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let p = [{ SearchText: this.BOMVersion1 }, { SearchText: this.BOMVersion2 }];
      let _result = await InventBomController.methods.getData(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        for (var i in _result) {
          if (_result[i][0]) {
            let _rt1 = await InventBomController.methods.getBomTree({ ItemId: _result[i][0].ItemId, BomID: _result[i][0].BOMId });
            if (!_.isNull(_rt1) && _rt1 && _rt1.length > 0) {
              let dt = _rt1[0], bm = {};
              this.setJsonData(dt, bm, _result[i][0].ItemId);
              if (_result[i][0].BOMId == this.BOMVersion1) {
                orig1 = JSON.stringify(_.cloneDeep(bm), null, 1)
              }
              if (_result[i][0].BOMId == this.BOMVersion2) {
                orig2 = JSON.stringify(_.cloneDeep(bm), null, 1)
              }
            }
          }
        }
      }
      if (this.prev == null) {
        this.msgToasts("BOM版本1暂无数据，无法对比！", "info");
        loading.close();
        return;
      }
      else if (this.current == null) {
        this.msgToasts("BOM版本2暂无数据，无法对比！", "info");
        loading.close();
        return;
      }

      this.isShow = true
      this.prev = orig1;
      this.current = orig2
      loading.close();
    },
    setJsonData(dt, m, itemId) {
      let theBomItems = _.filter(dt, { ItemId: itemId });
      _.each(theBomItems, (t) => {
        let cm = _.cloneDeep(t);
        delete cm.BOMId;
        let ck = t.DetailItemId + ":" + t.NameAlias
        m[ck] = cm;
        if (m[ck]) {
          for (var k in m[ck]) {
            let tm = _.find(this.bomDetailFields, { key: k });
            if (tm) {
              m[ck][tm.label] = m[ck][k];
              if (k == "ProductPartsType" && m[ck]["ProductPartsType"]) {
                let ppt_value = _.map(m[ck][k].split(","), (m) => {
                  return parseInt(m)
                });
                let pptype_base = []
                _.each(ppt_value, (pt) => {
                  if (pt) {
                    let pmt = _.find(this.$store.state.biz_data.baseData.ProductPartsType, { id: pt });
                    if (pmt) pptype_base.push(pmt.text)
                  }
                })
                m[ck][tm.label] = _.join(pptype_base, "/")
              }
            }
            if (k != ck) {
              delete m[ck][k]
            }
          }
        }
        this.setJsonData(dt, cm, t.DetailItemId);

      })
    },
    foldingChanged() {
      let cntx_dt = document.getElementsByClassName("d2h-cntx");
      // console.log(cntx_dt)
      _.each(cntx_dt, (t) => {
        if (t.className == "d2h-cntx")
          t.parentElement.style.display = this.folding ? "none" : "";
      })
    }
  }
}
</script>
<style scoped>
/* .d2h-ins {
  background-color: #f1c524;
  border-color: #f1c524;
} */
.d2h-file-side-diff {
  margin-bottom: -5px;
  /* overflow: scroll; */
}
.d2h-code-side-linenumber {
  padding: 0 0.5rem;
  position: relative;
  line-height: 20px;
  height: 20px;
  display: table-cell;
}

.el-card :deep(.el-card__body){
  flex: 1;
}
</style>
